import {
  camelCase, initial, split, upperCase,
  last, join, concat, map, reduce, once,
} from 'lodash';
import moment from 'moment';

export function getColorFromKey(key, rgb = false, fallback = true) {
  const k = camelCase(key);
  if (k === 'won') {
    return rgb ? '76,175,80' : '#4caf50';
  }
  if (k === 'lost') {
    return rgb ? '229,28,35' : '#e51c23';
  }
  if (k === 'noDecision') {
    return rgb ? '255,152,0' : '#ff9800';
  }
  if (fallback) {
    return rgb ? '44,62,80' : '#2c3e50';
  }
  return null;
}

export function getNameFromKey(stageKey) {
  let name = 'Unknown';
  if (stageKey === 'won') {
    name = 'Won';
  } else if (stageKey === 'lost') {
    name = 'Lost';
  } else if (stageKey === 'noDecision') {
    name = 'No Decision';
  }
  return name;
}

export function getAliasFromKey(stageKey) {
  let name = 'Unknown';
  if (stageKey === 'won') {
    name = 'Wins';
  } else if (stageKey === 'lost') {
    name = 'Losses';
  } else if (stageKey === 'noDecision') {
    name = 'No Decisions';
  }
  return name;
}

export function getTypeColorFromKey(key, rgb = false, alpha = 1) {
  const k = camelCase(key);
  let c = rgb ? '44,62,80' : '#2c3e50';

  if (k === 'newBusiness') {
    c = rgb ? '255, 208, 0' : '#ffd000';
  } else if (k === 'addOn') {
    c = rgb ? '255, 93, 171' : '#ff5dab';
  } else if (k === 'renewal') {
    c = rgb ? '198, 223, 95' : '#c6df5f';
  } else if (k === 'upsell') {
    c = rgb ? '0, 194, 181' : '#00c2b5';
  }
  return rgb ? `rgba(${c},${alpha})` : c;
}

export function getSizeColorFromKey(key, rgb = false, fallback = true) {
  const k = camelCase(key);

  if (k === 'small') {
    return rgb ? '0,188,212' : '#00bcd4';
  }
  if (k === 'medium') {
    return rgb ? '255,87,34' : '#ff5722';
  }
  if (k === 'large') {
    return rgb ? '139,195,74' : '#8bc34a';
  }
  if (fallback) {
    return rgb ? '44,62,80' : '#2c3e50';
  }
  return null;
}

export function getUserRoleColorFromKey(key, rgb = false, fallback = true) {
  const k = camelCase(key);

  if (k === 'admin') {
    return rgb ? '233,30,99' : '#e91e63'; // Soft pink
  }
  if (k === 'manager') {
    return rgb ? '3,169,244' : '#03a9f4'; // Muted sky blue
  }
  if (k === 'salesrep') {
    return rgb ? '205,220,57' : '#cddc39'; // Pastel lime green
  }
  if (fallback) {
    return rgb ? '44,62,80' : '#2c3e50';
  }
  return null;
}

export function formatRange(start, end, period = null) {
  let title = null;
  if (start && end) {
    /*
    if (period === 'month') {
      title = start.format('MMM YYYY');
    } else {
      let startFormat = 'DD MMM YYYY';
      if (start.isSame(end, 'month')) {
        startFormat = 'DD';
      } else if (start.isSame(end, 'year')) {
        startFormat = 'DD MMM';
      }
      title = `${start.format(startFormat)} - ${end.format('DD MMM YYYY')}`;
    }
    */
    if (period === 'month') {
      title = start.format('MMM YYYY');
    } else if (period === 'week') {
      title = `${start.format('MMM D')} - ${end.format('D, YYYY')}`;
    } else {
      title = `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
    }
  }
  return title;
}


export function isMacOS() {
  return (window && window.navigator.userAgent.indexOf('Mac OS X') !== -1);
}


export const allContactGDPROptions = [
  {
    label: 'All Contacts',
    value: null,
    text: 'All contacts names, emails and phone numbers are imported from your CRM instance to TruSales.',
  },
  {
    label: 'Contact location-based GDPR Compliance',
    value: 'contactCountry',
    text: 'TruSales will remove any contact\'s contact information (name, email, phone numbers) if the contact is located in one of the countries where GDPR is in place.',
  },
  {
    label: 'Opportunity location-based GDPR Compliance',
    value: 'accountCountry',
    text: `
      In addition to checking a contact's phone number to determine GDPR compliance,
      if an account for an opportunity is located in one of the countries where GDPR is in place,
      none of that opportunity's contacts' contact information (name, email, phone numbers)
      will be imported into TruSales.
    `,
  },
];

export const allSalesRepGDPROptions = [
  {
    label: 'All Information',
    value: null,
  },
  {
    label: 'Sales Rep GDPR Compliance',
    value: 'country',
  },
];


export function transalteLanguageCode(input) {
  const pieces = split(input, '-');
  const l = last(pieces);
  return join(concat(initial(pieces), l ? [upperCase(l)] : []), '-');
}
export function transalteLanguageCodes(inputs) {
  return map(inputs, input => transalteLanguageCode(input));
}

export const getPredefineDateRanges = once(() => {
  const format = 'YYYY-MM-DD';
  // const displayFormat = 'MMM DD, YYYY';
  const predefinedRanges = [
    {
      label: 'Last',
      ranges: reduce([
        { label: 'Year', value: 'year', slug: 'last-year' },
        { label: 'Quarter', value: 'quarter', slug: 'last-quarter' },
        { label: 'Month', value: 'month', slug: 'last-month' },
        { label: 'Week', value: 'week', slug: 'last-week' },
      ], (items, { label, value, slug }) => {
        items.push({
          label,
          slug,
          start: moment()
            .subtract(1, value)
            .startOf(value)
            .format(format),
          end: moment()
            .subtract(1, value)
            .endOf(value)
            .format(format),
        });
        return items;
      }, []),
    },
  
    {
      label: 'Next',
      isFuture: true,
      ranges: reduce([
        { label: 'Year', value: 'year', slug: 'next-year' },
        { label: 'Quarter', value: 'quarter', slug: 'next-quarter' },
        { label: 'Month', value: 'month', slug: 'next-month' },
        { label: 'Week', value: 'week', slug: 'next-week' },
      ], (items, { label, value, slug }) => {
        items.push({
          label,
          slug,
          start: moment()
            .add(1, value)
            .startOf(value)
            .format(format),
          end: moment()
            .add(1, value)
            .endOf(value)
            .format(format),
        });
        return items;
      }, []),
    },
  
    {
      label: 'This',
      ranges: reduce([
        { label: 'Year', value: 'year', slug: 'this-year' },
        { label: 'Quarter', value: 'quarter', slug: 'this-quarter' },
        { label: 'Month', value: 'month', slug: 'this-month' },
        { label: 'Week', value: 'week', slug: 'this-week' },
      ], (items, { label, value, slug }) => {
        items.push({
          label,
          slug,
          start: moment()
            .startOf(value)
            .format(format),
          end: moment()
            .endOf(value)
            .format(format),
        });
        return items;
      }, []),
    },
    {
      label: 'To Date',
      ranges: reduce([
        {
          label: 'Year to Date (YTD)', value: 'year', displayLabel: 'Year to Date', slug: 'ytd',
        },
        {
          label: 'Quarter to Date (QTD)', value: 'quarter', displayLabel: 'Quarter to Date', slug: 'qtd',
        },
        {
          label: 'Month to Date (MTD)', value: 'month', displayLabel: 'Month to Date', slug: 'mtd',
        },
        {
          label: 'Week to Date (WTD)', value: 'week', displayLabel: 'Week to Date', slug: 'wtd',
        },
      ], (items, {
        label, displayLabel, value, slug,
      }) => {
        items.push({
          label,
          slug,
          displayLabel,
          start: moment()
            .startOf(value)
            .format(format),
          end: moment()
            .endOf('day')
            .format(format),
        });
        return items;
      }, []),
    },
    {
      label: 'Current Date',
      ranges: reduce([
        {
          label: 'Current Date',
          displayLabel: 'Current Date',
          slug: 'cd',
          start: moment().startOf('date').format(format),
          end: moment().endOf('date').format(format),
        },
        {
          label: 'Up to Current Date',
          displayLabel: 'Up to Current Date',
          slug: 'ucd',
          start: null,
          end: moment().endOf('date').format(format),
        },
        {
          label: 'Before Current Date',
          displayLabel: 'Before Current Date',
          slug: 'bcd',
          start: null,
          end: moment().subtract(1, 'days').endOf('date').format(format),
        },
        {
          label: 'After Current Date',
          displayLabel: 'After Current Date',
          slug: 'acd',
          start: moment().add(1, 'days').startOf('day').format(format),
          end: null,
        },
        {
          label: 'Starting from Current Date',
          displayLabel: 'Starting from Current Date',
          slug: 'scd',
          start: moment().startOf('day').format(format),
          end: null,
        },
      ], (items, {
        label, displayLabel, slug, start, end,
      }) => {
        items.push({
          label,
          slug,
          displayLabel,
          start,
          end,
        });
        return items;
      }, []),
    },
    {
      label: 'Trailing',
      ranges: reduce([
        {
          label: '3 Years', value: 'years', numbericValue: 3, slug: 'last-3-years',
        },
        {
          label: '2 Years', value: 'years', numbericValue: 2, slug: 'last-2-years',
        },
        {
          label: '18 Months', value: 'months', numbericValue: 18, slug: 'last-18-months',
        },
        {
          label: '12 Months', value: 'months', numbericValue: 12, slug: 'last-12-months',
        },
        {
          label: '6 Months', value: 'months', numbericValue: 6, slug: 'last-6-months',
        },
        {
          label: '90 Days', value: 'days', numbericValue: 90, slug: 'last-90-days',
        },
        {
          label: '60 Days', value: 'days', numbericValue: 60, slug: 'last-60-days',
        },
        {
          label: '30 Days', value: 'days', numbericValue: 30, slug: 'last-30-days',
        },
        {
          label: '7 Days', value: 'days', numbericValue: 7, slug: 'last-7-days',
        },
      ], (items, {
        label, numbericValue, value, slug,
      }) => {
        const offset = value === 'days' ? 1 : 0;
        items.push({
          label,
          slug,
          displayLabel: `Trailing ${label}`,
          start: moment()
            .subtract(numbericValue - offset, value)
            .startOf('day')
            .format(format),
          end: moment()
            .endOf('day')
            .format(format),
        });
        return items;
      }, []),
    },
  
    {
      label: 'Following',
      isFuture: true,
      ranges: reduce([
        {
          label: '12 Months', value: 'months', numbericValue: 12, slug: 'following-12-months',
        },
        {
          label: '6 Months', value: 'months', numbericValue: 6, slug: 'following-6-months',
        },
        {
          label: '90 Days', value: 'days', numbericValue: 90, slug: 'following-90-days',
        },
        {
          label: '60 Days', value: 'days', numbericValue: 60, slug: 'following-60-days',
        },
        {
          label: '30 Days', value: 'days', numbericValue: 30, slug: 'following-30-days',
        },
        {
          label: '7 Days', value: 'days', numbericValue: 7, slug: 'following-7-days',
        },
      ], (items, {
        label, numbericValue, value, slug,
      }) => {
        const offset = value === 'days' ? 1 : 0;
        items.push({
          label,
          slug,
          displayLabel: `Following ${label}`,
          start: moment()
            .startOf('day')
            .format(format),
          end: moment()
            .add(numbericValue - offset, value)
            .endOf('day')
            .format(format),
        });
        return items;
      }, []),
    },
  
  ];
  return predefinedRanges;
});



const abbrs = {
  EST : 'Eastern Standard Time',
  EDT : 'Eastern Daylight Time',
  CST : 'Central Standard Time',
  CDT : 'Central Daylight Time',
  MST : 'Mountain Standard Time',
  MDT : 'Mountain Daylight Time',
  PST : 'Pacific Standard Time',
  PDT : 'Pacific Daylight Time',
};

export function getTimeZoneName(mm) {
  if (!mm || !mm.isValid()) {
    return null;
  }
  const abbr = mm.zoneAbbr();
  return abbrs[abbr] || abbr;
};